





































import Vue from 'vue'
import { Component, Watch, Prop, Emit } from 'vue-property-decorator'

import AppDatePicker from '@/components/AppDatePicker.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppTextarea from '@/components/AppTextarea.vue'
import AppDialog from '@/components/AppDialog.vue'
import dollarFilter from '@/utils/dollarFilter'

import {
  premiumStatusKeys, premiumstatusValues,
  paymentMethodKeys, paymentMethodValues,
  commissionMethodKeys, commissionMethodValues
} from '@/modules/Policy/helpers/policy'
import { newPolicyPayment, newPolicyCommission } from '@/modules/Policy/gql/policy.gql'
import { SnackType } from '@/interfaces/snack'
import { Policy } from '@/modules/Policy/interfaces/policy'
import { showErrors, showNotification } from '@/utils/snack'

@Component({
  components: {
    AppTextField,
    AppSelector,
    AppTextarea,
    AppDatePicker,
    AppDialog
  }
})
export default class PolicyPaymentDialog extends Vue {
  @Prop({ type: Boolean }) readonly show!: boolean
  @Prop({ type: String }) readonly title!: string
  @Prop({ type: Boolean }) readonly disable!: boolean
  @Prop({ type: String }) readonly dialogType!: string
  @Prop({ type: Object as () => Policy }) readonly policy!: Policy
  @Prop({ type: Number }) readonly totalCommission!: number

  showDialog = false

  paymentInput: {
    [key: string]: any;
  } = {
    amount: '',
    receivedDate: '',
    statusIndex: -1,
    notes: ''
  }

  statusOptions = premiumstatusValues
  paymentMethodOptions = paymentMethodValues
  commissionMethodPotions = commissionMethodValues

  get methodOptions () {
    return this.dialogType === 'payment'
      ? this.paymentMethodOptions
      : this.commissionMethodPotions
  }

  get showWarning () {
    return this.totalCommission && +this.paymentInput.amount > this.totalCommission
  }

  dollarFilter = dollarFilter

  @Watch('show')
  onShowChanged (val: boolean) {
    this.showDialog = val
  }

  @Emit('post')
  onPostHandler () {
    // do nothing
  }

  @Emit('success')
  onSuccess () {
    // do nothing
  }

  clearPaymentInput () {
    this.paymentInput = {
      amount: '',
      receivedDate: '',
      statusIndex: -1,
      methodIndex: -1,
      notes: ''
    }
    this.onPostHandler()
  }

  async paymentConfirm () {
    if (this.dialogType === 'payment') {
      await this.newPayment()
    } else if (this.dialogType === 'commission') {
      await this.newCommission()
    }
  }

  async newPayment () {
    const {
      amount, receivedDate, statusIndex, methodIndex, notes
    } = this.paymentInput

    const newPaymentValid = (this.$refs.form as Vue & { validate: () => boolean }).validate()
    if (!newPaymentValid) {
      return
    }

    try {
      const res = await this.$apollo.mutate({
        mutation: newPolicyPayment,
        variables: {
          paymentInput: {
            policyId: Number(this.policy.id),
            amount: Number(amount),
            status: premiumStatusKeys[statusIndex],
            paymentMethod: paymentMethodKeys[methodIndex],
            notes,
            receivedDate
          }
        }
      })
      showNotification({
        msg: 'Create the new policy payment successfully',
        type: SnackType.Success
      })
      this.clearPaymentInput()
      this.onSuccess()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async newCommission () {
    const {
      amount, receivedDate, statusIndex, methodIndex, notes
    } = this.paymentInput

    const newCommissionValid = (this.$refs.form as Vue & { validate: () => boolean }).validate()
    if (!newCommissionValid) {
      return
    }

    try {
      const res = await this.$apollo.mutate({
        mutation: newPolicyCommission,
        variables: {
          commissionInput: {
            policyId: Number(this.policy.id),
            amount: Number(amount),
            status: premiumStatusKeys[statusIndex],
            paymentMethod: commissionMethodKeys[methodIndex],
            notes,
            receivedDate
          }
        }
      })
      showNotification({
        msg: 'Create the new policy commission successfully',
        type: SnackType.Success
      })
      this.clearPaymentInput()
      this.onSuccess()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
}

